import React from 'react';
import { Card, Upload, Button, message, Space, Typography } from 'antd';
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const TrafficCardImport: React.FC = () => {
  const handleUpload = (info: any) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} 文件上传成功`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} 文件上传失败`);
    }
  };

  const downloadTemplate = () => {
    message.info('下载模板功能待实现');
  };

  return (
    <div>
      <Card>
        <Title level={3}>流量卡导入</Title>
        <Paragraph>
          请上传包含流量卡信息的Excel文件，支持批量导入流量卡数据。
        </Paragraph>

        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Card title="上传文件" size="small">
            <Space direction="vertical" size="middle">
              <Paragraph>
                支持的文件格式：.xlsx, .xls, .csv
                <br />
                文件大小限制：10MB
              </Paragraph>
              
              <Upload
                name="file"
                action="/api/traffic/import"
                onChange={handleUpload}
                accept=".xlsx,.xls,.csv"
                maxCount={1}
              >
                <Button icon={<UploadOutlined />} type="primary">
                  选择文件
                </Button>
              </Upload>
            </Space>
          </Card>

          <Card title="操作说明" size="small">
            <Paragraph>
              <ul>
                <li>请先下载模板文件，按照模板格式填写数据</li>
                <li>确保必填字段完整，数据格式正确</li>
                <li>支持批量导入，单次最多可导入1000条记录</li>
                <li>导入过程中请勿关闭页面</li>
              </ul>
            </Paragraph>
            
            <Button 
              icon={<DownloadOutlined />} 
              onClick={downloadTemplate}
            >
              下载模板
            </Button>
          </Card>

          <Card title="导入记录" size="small">
            <Paragraph>
              最近导入记录将在这里显示
            </Paragraph>
          </Card>
        </Space>
      </Card>
    </div>
  );
};

export default TrafficCardImport; 